import { Component,EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  @Input() offerStatus;
  @Output() onCloseDialog:EventEmitter<any> = new EventEmitter<any>();
  @Output() onOffer: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit(): void {
  }

  closeDialog(){
    this.onCloseDialog.emit(null);
  }

}
